import { gql, useMutation } from '@apollo/client';
import type {
  UpdateAnnotationMutation,
  UpdateAnnotationMutationVariables,
} from '../../graphql/generated/graphqlTypes';

const UPDATE_ANNOTATION = gql`
  mutation updateAnnotation($id: ID!, $content: Json, $link: String) {
    updateAnnotation(id: $id, content: $content, link: $link) {
      id
      content
      link
    }
  }
`;

function useUpdateAnnotation() {
  return useMutation<
    UpdateAnnotationMutation,
    UpdateAnnotationMutationVariables
  >(UPDATE_ANNOTATION);
}

export default useUpdateAnnotation;
